$('.js-slick-smartphone-slider').slick({
    infinite: true,
    arrows: false,
    dots: true,
    autoplay: true,
});